import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const ServerConfigurationsApp = lazy(() => import('./ServerToolsApp'));

const MobilityAppConfig = {
  settings: {
    layout: {},
  },
  auth: authRoles.adminProvider,
  routes: [
    {
      path: 'apps/mobility',
      element: <ServerConfigurationsApp />,
    },
  ],
};

export default MobilityAppConfig;
